var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFailedLogins(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 9.33333C6.18889 9.33333 6.34722 9.26945 6.475 9.14167C6.60278 9.01389 6.66667 8.85556 6.66667 8.66667C6.66667 8.47778 6.60278 8.31944 6.475 8.19167C6.34722 8.06389 6.18889 8 6 8C5.81111 8 5.65278 8.06389 5.525 8.19167C5.39722 8.31944 5.33333 8.47778 5.33333 8.66667C5.33333 8.85556 5.39722 9.01389 5.525 9.14167C5.65278 9.26945 5.81111 9.33333 6 9.33333ZM5.33333 6.66667H6.66667V2.66667H5.33333V6.66667ZM3.5 12L0 8.5V3.5L3.5 0H8.5L12 3.5V8.5L8.5 12H3.5Z",
    fill: "#F37171"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFailedLogins);
export default __webpack_public_path__ + "static/media/failedLogins.596d7ab601d4e2ec58f27649ffa76221.svg";
export { ForwardRef as ReactComponent };